import React, { useState } from 'react';
import { TaskTypeEnum } from '../enums/taskTypeEnum';
import { UrgencyEnum, getUrgency } from '../enums/urgencyEnum';
import { CustomDropdown, getAssigneeName, createAssigneeOptions, getAssigneeIcon, outOfOfficeForAssignee } from '@medprompt/shared';
import './AddOutcomeTaskForm.css';

const AddOutcomeTaskForm = ({ activeUsers = [], teams = [], onConfirm, onCancel }) => {
  const initialTaskType = Object.keys(TaskTypeEnum)[0] ?? '';
  const [text, setText] = useState('');
  const [taskType, setTaskType] = useState(initialTaskType);
  const [assigneeId, setAssigneeId] = useState(null);
  const [isUrgent, setIsUrgent] = useState(false);
  const [isTaskTypeDropdownOpen, setIsTaskTypeDropdownOpen] = useState(false);
  const [isAssigneeDropdownOpen, setIsAssigneeDropdownOpen] = useState(false);
  const [isUrgencyDropdownOpen, setIsUrgencyDropdownOpen] = useState(false);

  const isValid = text.trim() && taskType;

  const handleConfirm = () => {
    if (!isValid) return;
    onConfirm({
      text: text.trim(),
      taskType,
      assigneeId: assigneeId ?? null,
      isUrgent
    });
  };

  const taskTypeOptions = Object.keys(TaskTypeEnum).map(key => ({
    id: key,
    description: TaskTypeEnum[key].description,
    icon: TaskTypeEnum[key].icon
  }));

  const urgencyOptions = [
    { id: true,  description: UrgencyEnum.URGENT.description, icon: UrgencyEnum.URGENT.icon },
    { id: false, description: UrgencyEnum.NORMAL.description, icon: UrgencyEnum.NORMAL.icon }
  ];

  const assigneeOptions = createAssigneeOptions(activeUsers, teams);
  const currentUrgency = getUrgency(isUrgent);
  const assigneeIcon = getAssigneeIcon(assigneeId, activeUsers, teams);
  const assigneeDisplayName = getAssigneeName(assigneeId, activeUsers, teams);

  return (
    <div className="document-ai-item add-measurement-segment">
      <div className="outcome-details">
        <div className="task-text-container">
          <textarea
            value={text}
            onChange={(e) => setText(e.target.value)}
            className="task-edit-textarea"
            placeholder="Describe the outcome task..."
            rows="3"
            autoFocus
          />
        </div>

        <div className="custom-select-container-items">
          <div className="custom-select-container">
            <CustomDropdown
              selected={currentUrgency.description}
              selectedIcon={currentUrgency.icon}
              options={urgencyOptions}
              isOpen={isUrgencyDropdownOpen}
              toggleDropdown={() => setIsUrgencyDropdownOpen(!isUrgencyDropdownOpen)}
              onSelect={(option) => {
                setIsUrgent(option.id);
                setIsUrgencyDropdownOpen(false);
              }}
              selectedStyle={{
                backgroundColor: currentUrgency.color,
                color: '#000',
                fontWeight: 'bold',
                padding: '4px 8px',
                borderRadius: '4px'
              }}
            />
          </div>
          <div className="custom-select-container">
            <CustomDropdown
              selected={TaskTypeEnum[taskType]?.description || 'Select Task Type'}
              selectedIcon={TaskTypeEnum[taskType]?.icon}
              options={taskTypeOptions}
              isOpen={isTaskTypeDropdownOpen}
              toggleDropdown={() => setIsTaskTypeDropdownOpen(!isTaskTypeDropdownOpen)}
              onSelect={(option) => {
                setTaskType(option.id);
                setIsTaskTypeDropdownOpen(false);
              }}
            />
          </div>
          {taskType === 'PATIENT_NOTE' ? (
            <div style={{ display: 'flex', alignItems: 'center', padding: '8px 12px' }}>
              <p style={{ fontSize: '0.9em', color: '#666', fontStyle: 'italic', margin: 0 }}>
                Patient message tasks are excluded when filing away
              </p>
            </div>
          ) : (
            <div className="custom-select-container">
              <CustomDropdown
                selected={assigneeDisplayName}
                selectedIcon={assigneeIcon}
                selectedOutOfOffice={outOfOfficeForAssignee(assigneeId, activeUsers)}
                options={assigneeOptions}
                isOpen={isAssigneeDropdownOpen}
                toggleDropdown={() => setIsAssigneeDropdownOpen(!isAssigneeDropdownOpen)}
                onSelect={(option) => {
                  setAssigneeId(option.userId ?? null);
                  setIsAssigneeDropdownOpen(false);
                }}
                keyExtractor={(option) => option.id}
              />
            </div>
          )}
        </div>
      </div>

      <div className="add-task-form-actions">
        <button type="button" className="add-measurement-form-cancel-button" onClick={onCancel}>
          Cancel
        </button>
        <button
          type="button"
          className="header-button header-button-primary"
          onClick={handleConfirm}
          disabled={!isValid}
        >
          Add Task
        </button>
      </div>
    </div>
  );
};

export default React.memo(AddOutcomeTaskForm);
